import { BasicDropdownType, TableCols } from '../interfaces/static-data';
import { SENIORITY_LEVEL_ITEMS } from './reference-obligation';
import { mapToDropdownItem } from './static-data.utils';

export const OBLIGATION_CATEGORY_ITEMS: BasicDropdownType[] = mapToDropdownItem(
  ['PAYMENT', 'BORROWED_MONEY', 'BOND', 'LOAN', 'BOND_OR_LOAN']
);

export const OBLIGATION_CHARACTERISTICS_ITEMS: BasicDropdownType[] =
  mapToDropdownItem([
    'NOT_SUBORDINATED',
    'SPECIFIED_CURRENCY',
    'SPECIFIED_CURRENCY_STANDARD_SPECIFIED_CURRENCIES',
    'SPECIFIED_CURRENCY_STANDARD_SPECIFIED_CURRENCIES_AND_DOMESTIC_CURRENCY',
    'NOT_SOVEREIGN_LENDER',
    'NOT_DOMESTIC_CURRENCY',
    'NOT_DOMESTIC_LAW',
    'LISTED',
    'NOT_DOMESTIC_ISSUANCE',
  ]);

export const REFERENCE_ENTITY: TableCols[] = [
  {
    key: 'longName',
    displayValue: 'Reference Entity Name',
  },
  {
    key: 'seniorityLevel',
    displayValue: 'Seniority Level',
    type: 'select',
    items: SENIORITY_LEVEL_ITEMS,
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'transactionType',
    displayValue: 'Transaction Type',
    type: 'select',
    items: [],
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'moodysRating',
    displayValue: "Moody's Rating",
  },
  {
    key: 'moodysRatingEffectiveDate',
    displayValue: "Moody's Rating Effective Date",
    mask: '0000-00-00',
  },
  {
    key: 'spRating',
    displayValue: 'S&P Rating',
  },
  {
    key: 'spRatingEffectiveDate',
    displayValue: 'S&P Rating Effective Date',
    mask: '0000-00-00',
  },
  {
    key: 'fitchRating',
    displayValue: 'Fitch Rating',
  },
  {
    key: 'fitchRatingEffectiveDate',
    displayValue: 'Fitch Rating Effective Date',
    mask: '0000-00-00',
  },
  {
    key: 'currency',
    displayValue: 'Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'domesticCurrency',
    displayValue: 'Domestic Currency',
    type: 'select',
    selectOptions: {
      searchable: true,
    },
  },
  {
    key: 'restructuring',
    displayValue: 'Restructuring',
    type: 'select',
    items: [
      { id: 'MOD_R', displayValue: 'Modified Restructuring' },
      { id: 'MOD_MOD_R', displayValue: 'Modified Modified Restructuring ' },
      { id: 'NO_RESTRUCTURING', displayValue: 'No Restructuring' },
      { id: 'FULL_RESTRUCTURING', displayValue: 'Full Restructuring' },
    ],
  },
  {
    key: 'website',
    displayValue: 'Website',
  },
  {
    key: 'description',
    displayValue: 'Description',
    type: 'textarea',
  },
];
